import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Defensive: strip any trailing dot from the backend URL. A trailing-dot
// FQDN (e.g. "https://host.emergent.host.") is silently normalized by
// Chromium/curl but fails Safari/WebKit's stricter TLS trust validation,
// causing a platform-specific "Load failed" error - this guard prevents
// a misconfigured env var from ever reproducing that outage again.
export function getApiUrl() {
  return (process.env.REACT_APP_BACKEND_URL || '').replace(/\.$/, '');
}
